export const USER_EMAIL_KEY = 'userEmail';
export const FISCAL_YEAR_KEY = 'fiscalYear';

export const DROMO_QUOTA_FIELDS = [
    {
        label: 'User email',
        key: USER_EMAIL_KEY,
        type: 'string',
        validators: [
            {
                validate: 'required',
            },
        ],
        alternateMatches: ['Email', 'User Email', 'email', 'username'],
    },
    {
        label: 'Fiscal year',
        key: FISCAL_YEAR_KEY,
        // Default number preset uses thousand separators (e.g. 2,026); plain does not.
        type: ['number', 'plain'] as [string, string],
        validators: [
            {
                validate: 'required',
            },
        ],
        alternateMatches: ['Fiscal Year', 'Year', 'fiscal year', 'year'],
    },
    {label: 'Jan', key: 'jan', type: 'number', alternateMatches: ['January', 'january']},
    {
        label: 'Feb',
        key: 'feb',
        type: 'number',
        alternateMatches: ['February', 'february'],
    },
    {label: 'Mar', key: 'mar', type: 'number', alternateMatches: ['March', 'march']},
    {label: 'Apr', key: 'apr', type: 'number', alternateMatches: ['April', 'april']},
    {label: 'May', key: 'may', type: 'number', alternateMatches: ['May', 'may']},
    {label: 'Jun', key: 'jun', type: 'number', alternateMatches: ['June', 'june']},
    {label: 'Jul', key: 'jul', type: 'number', alternateMatches: ['July', 'july']},
    {label: 'Aug', key: 'aug', type: 'number', alternateMatches: ['August', 'august']},
    {
        label: 'Sep',
        key: 'sep',
        type: 'number',
        alternateMatches: ['September', 'september'],
    },
    {label: 'Oct', key: 'oct', type: 'number', alternateMatches: ['October', 'october']},
    {
        label: 'Nov',
        key: 'nov',
        type: 'number',
        alternateMatches: ['November', 'november'],
    },
    {
        label: 'Dec',
        key: 'dec',
        type: 'number',
        alternateMatches: ['December', 'december'],
    },
];
